const headerData = [{
		types: "selection",
		columnwidth: 40,
	},
	{
		prop: "CusName",
		label: "经销商",
	},
	{
		prop: "BOSSName",
		label: "公司负责人",
		columnwidth: 80,
	},
	{
		prop: "CustomerProvince",
		label: "经营省份",
		columnwidth: 80,
	}
];
export default headerData;